import React from "react";
import DoctorSideBar from './DoctorSideBar';

function Profile(){

    return(

        <>
          
          <div className="d-flex" id="wrapper">
      <DoctorSideBar />
        <div id="page-content-wrapper">
          <div className="container-fluid sidebarcontentcontainer">
           
        </div>
        </div>
        </div>
        



        </>
    )
}

export default Profile;